import React from "react";

export const SvgEdit = (props) => {
	return (
		<div>
			<svg
				width="13"
				height="13"
				viewBox="0 0 13 13"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M12.7968 2.67367L10.3264 0.202973C10.1966 0.0729511 10.0204 0 9.83663 0C9.65283 0 9.47687 0.0729511 9.34689 0.202973L1.17282 8.377C1.08878 8.46083 1.02806 8.56473 0.995727 8.6788L0.0259178 12.1193C-0.0419642 12.3606 0.0257052 12.6197 0.203014 12.797C0.334631 12.9286 0.511514 13 0.692757 13C0.755322 13 0.818596 12.9915 0.880487 12.9741L4.32099 12.0043C4.43527 11.972 4.53921 11.911 4.623 11.8272L12.7968 3.65319C13.0674 3.38276 13.0674 2.94403 12.7968 2.67367ZM3.77141 10.7198L1.69489 11.3049L2.28024 9.22881L9.83663 1.67245L11.3276 3.16341L3.77141 10.7198Z"
					fill={props.color ? props.color : "#666666"}
				/>
			</svg>
		</div>
	);
};
